import { render, staticRenderFns } from "./pageManage.vue?vue&type=template&id=58c1f039&scoped=true&"
import script from "./pageManage.vue?vue&type=script&lang=js&"
export * from "./pageManage.vue?vue&type=script&lang=js&"
import style0 from "./pageManage.vue?vue&type=style&index=0&id=58c1f039&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1f039",
  null
  
)

export default component.exports